/*
 * @Author: your name
 * @Date: 2021-10-11 11:44:01
 * @LastEditTime: 2021-10-14 10:07:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mrc\src\service\api\staffType.js
 */
//员工关系
import http from '../httpConfig'

const table = "mrbase_sys_correlation"

// 员工关系列表
export const staff_relation_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/correlation/list-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 新增员工关系
export const staff_relation_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/correlation/add-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改员工关系
export const staff_relation_edit = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/correlation/update-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 查询员工关系详情
export const staff_relation_detail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/correlation/find-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除员工关系
export const staff_relation_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/correlation/delete-correlation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

